import { Grid } from "@material-ui/core";
import CurrencyFormat from "react-currency-format";
import * as S from "./styles";

import { useHistory } from "react-router-dom";
import ThemeButton from "../ThemeButton";

import CheckIcon from "@material-ui/icons/Check";
import { useEffect, useState } from "react";
import { useGlobal } from "../../contexts/globalContext";
import CarouselComponent from "../Carousel";
import RegisterModal from "../RegisterModal";
import RoomRate from "./RoomRate";
import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";

const Room = ({
  roomName,
  nights,
  policies,
  roomDetails,
  hotel,
  hotelDetails,
  searchState,
  buscaAtual,
  room,
  isMultipleSelection = false,
  onRoomSelect,
  isSelected = false,
}) => {
  const { user, signed } = useGlobal();
  const [isOpenRegisterModal, setIsOpenRegisterModal] = useState(false);
  const [shortenCoinAlias, setShortenCoinAlias] = useState("Pts");
  // const roomImages =
  //   roomDetails?.multimediaDescriptionsType.multimediaDescriptions[1]?.imageItemsType?.imageItems.map(
  //     (image) => image.url?.address
  //   );

  const getValuesByUser = (val) => {
    let value = signed
      ? val * user.catalog.catalogCurrencyConfig.conversionRate
      : val;

    return signed ? Math.ceil(Math.round(value)) : value;
  };

  let history = useHistory();

  const [rateSelected, setRateSelected] = useState(room.roomRates[0]);

  const onChangeRate = (rate) => setRateSelected(rate);

  const arrayImgs =
    room.guestRoom?.multimediaDescriptionsType?.multimediaDescriptions[1]?.imageItemsType?.imageItems.map(
      (imgs) => imgs.url.address,
    ) || [];

  const getCancellationLabel = () => {
    const cancellationPolicies =
      rateSelected?.cancellationPolicies || room?.roomRates?.[0]?.cancellationPolicies;
    if (!cancellationPolicies) return null;

    if (cancellationPolicies.refundable === false) {
      return { text: "Não reembolsável", type: "nonRefundable" };
    }

    const penalties = cancellationPolicies.penalties || [];
    const freeCancelPenalty = penalties.find((p) => p.from);
    if (freeCancelPenalty?.from) {
      try {
        const dateFormatted = format(parseISO(freeCancelPenalty.from), "dd/MM/yyyy", { locale: pt });
        return { text: `Cancelamento grátis até ${dateFormatted}`, type: "freeCancellation" };
      } catch {
        return null;
      }
    }

    if (cancellationPolicies.refundable === true) {
      return { text: "Reembolsável", type: "freeCancellation" };
    }

    return null;
  };

  const cancellationLabel = getCancellationLabel();

  useEffect(() => {
    setShortenCoinAlias(
      user?.campaign?.campaignConfig?.shortenCoinAlias || "Pts",
    );
  }, [user?.campaign?.campaignConfig?.shortenCoinAlias]);

  const handleRegisterModal = () => setIsOpenRegisterModal((prev) => !prev);
  const handleChooseRoom = () => {
    if (isMultipleSelection) {
      if (onRoomSelect) {
        onRoomSelect(room, rateSelected);
      }
      return;
    }

    let hotelRooms = [];

    if (searchState?.qtRooms > 1) {
      for (let i = 0; i < searchState.qtRooms; i++) {
        const hotelRoom = hotel.roomStays.roomTypes.filter(
          (r) => r.roomRates[0].roomStayCandidateRph === i,
        )[i];
        const roomRate = hotelRoom?.roomRates[0];
        hotelRooms.push({
          roomName,
          nights,
          totalTax:
            roomRate?.[
              roomRate.total.currencyCode === "BRL"
                ? "total"
                : "origTotal" || "total"
            ].amountAfterTax,
          policies,
          roomDetails,
          hotel,
          searchState,
          rateSelected: roomRate,
          room: hotelRoom,
          refToken: hotelRoom?.refToken || roomRate?.refToken,
          key: hotelRoom?.key || roomRate?.key,
        });
      }
      sessionStorage.setItem("@roomSelected", JSON.stringify(hotelRooms));
    } else {
      sessionStorage.setItem(
        "@roomSelected",
        JSON.stringify([
          {
            roomName,
            nights,
            totalTax:
              rateSelected?.[
                rateSelected.total.currencyCode === "BRL"
                  ? "total"
                  : "origTotal" || "total"
              ].amountAfterTax,
            policies,
            roomDetails,
            hotel,
            searchState,
            rateSelected,
            room,
            refToken: room?.refToken || rateSelected?.refToken,
            key: room?.key || rateSelected?.key,
          },
        ]),
      );
    }

    if (user?.guest || user?.travelVoucher) {
      return handleRegisterModal();
    }
    history.push("/busca/resumo");
  };

  return (
    <S.Wrapper isSelected={isSelected}>
      <RegisterModal
        open={isOpenRegisterModal}
        onClose={handleRegisterModal}
        travelVoucherUser={user?.travelVoucher}
      />
      <Grid container spacing={2}>
        <S.GridFlexible item xs={12} lg={3}>
          <S.RoomImageContainer>
            <CarouselComponent
              buscaAtual={buscaAtual}
              type="card-room"
              images={arrayImgs}
            />
          </S.RoomImageContainer>
        </S.GridFlexible>
        <S.GridFlexible item xs={12} lg={6}>
          <S.RoomName>{roomName}</S.RoomName>
          {room.guestRoom?.amenitiesType?.roomAmenities?.length > 0 && (
            <S.Amenities>
              {room.guestRoom.amenitiesType.roomAmenities
                .slice(0, 8)
                .map((amenitie, index) => (
                  <span key={index}>
                    <CheckIcon fontSize="small" />
                    {amenitie.roomAmenity}
                  </span>
                ))}
              {room.guestRoom.amenitiesType.roomAmenities.length > 8 && (
                <span style={{ background: "#e0e0e0", color: "#666" }}>
                  +{room.guestRoom.amenitiesType.roomAmenities.length - 8} mais
                </span>
              )}
            </S.Amenities>
          )}
          <S.DescriptionContainer>
            <S.Description>Descrição</S.Description>
            <span>
              {room?.roomDescription?.description ||
                room?.roomRates[0]?.description}
            </span>
          </S.DescriptionContainer>
          {cancellationLabel && (
            <S.CancellationPolicy type={cancellationLabel.type}>
              {cancellationLabel.text}
            </S.CancellationPolicy>
          )}
          <S.RoomRatesContainer>
            {room.roomRates.map((rate) => (
              <RoomRate
                rate={rate}
                onChangeRate={onChangeRate}
                rateSelected={rateSelected}
                buscaAtual={buscaAtual}
              />
            ))}
          </S.RoomRatesContainer>
        </S.GridFlexible>
        <S.GridFlexible item xs={12} lg={3}>
          <S.PriceDetails>
            <S.TotalValue>
              {signed &&
              !user?.guest &&
              !user?.campaign?.disablePointActivity ? (
                <span>
                  {getValuesByUser(
                    rateSelected?.[
                      rateSelected.total.currencyCode === "BRL"
                        ? "total"
                        : "origTotal" || "total"
                    ].amountAfterTax,
                  )}{" "}
                  {shortenCoinAlias}
                </span>
              ) : (
                <CurrencyFormat
                  value={getValuesByUser(
                    rateSelected?.[
                      rateSelected.total.currencyCode === "BRL"
                        ? "total"
                        : "origTotal" || "total"
                    ].amountAfterTax,
                  )}
                  displayType={"text"}
                  decimalSeparator=","
                  decimalScale={2}
                  prefix={"R$ "}
                />
              )}
            </S.TotalValue>
            <S.NightsQty>por {nights} noite(s) x 1 quarto</S.NightsQty>
            <S.DailyValue>
              {signed &&
              !user?.guest &&
              !user?.campaign?.disablePointActivity ? (
                <span>
                  {getValuesByUser(
                    rateSelected?.[
                      rateSelected.total.currencyCode === "BRL"
                        ? "total"
                        : "origTotal" || "total"
                    ].amountAfterTax / nights,
                  )}{" "}
                  {shortenCoinAlias}
                </span>
              ) : (
                <CurrencyFormat
                  value={getValuesByUser(
                    rateSelected?.[
                      rateSelected.total.currencyCode === "BRL"
                        ? "total"
                        : "origTotal" || "total"
                    ].amountAfterTax / nights,
                  )}
                  displayType={"text"}
                  decimalSeparator=","
                  decimalScale={2}
                  prefix={"R$ "}
                />
              )}
              /diária
            </S.DailyValue>

            {policies &&
              policies.map((policie) => (
                <S.Policies>
                  <S.PoliciesTitle>Politicas de cancelamento</S.PoliciesTitle>
                  <p>
                    <strong>Nome: </strong>
                    {policie.name}
                    <br />
                    <strong>Descrição: </strong>
                    {policie.description}
                    <br />
                    <strong>Valor (R$): </strong>
                    {policie.value}
                    <br />
                    <strong>Valor (%): </strong>
                    {policie.percent}
                  </p>
                </S.Policies>
              ))}
            <ThemeButton
              onClick={() => {
                handleChooseRoom();
              }}
              className="choose-hotel"
              disabled={isMultipleSelection && isSelected}
            >
              {isMultipleSelection && isSelected
                ? "Quarto Selecionado"
                : isMultipleSelection
                ? "Adicionar Quarto"
                : "Escolher Quarto"}
            </ThemeButton>
          </S.PriceDetails>
        </S.GridFlexible>
      </Grid>
    </S.Wrapper>
  );
};

export default Room;
